var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poprun_header_page"},[_c('div',{staticClass:"logo_box"},[_c('img',{style:({ width: '3.1875rem', height: '3.1875rem', cursor: 'pointer' }),attrs:{"src":require("@/assets/images/m/logo.png"),"alt":"logo"},on:{"click":_vm.goShequ}})]),_c('div',{staticClass:"right_setting"},[_c('img',{style:({ cursor: 'pointer' }),attrs:{"src":require("@/assets/images/m/icon-username.png"),"alt":"user"},on:{"mouseenter":_vm.showMenu}}),(_vm.visible)?_c('div',{on:{"mouseleave":_vm.hideMenu}},[(_vm.isLogin)?_c('div',{staticClass:"menu-container"},[(_vm.userInfo.username)?_c('div',{style:({
            marginBottom: '.5625rem',
            fontSize: '1.5625rem',
            color: '#F2F2F7',
            lineHeight: '2.0625rem',
            textAlign: 'center',
          })},[_vm._v(" "+_vm._s(_vm.userInfo.username)+" ")]):_vm._e(),(_vm.userInfo.username)?_c('div',{style:({ width: '100%', border: '.0625rem dashed #333' })}):_vm._e(),_c('div',{style:({
            fontSize: '1.5625rem',
            color: '#F2F2F7',
            lineHeight: '2.0625rem',
            marginTop: '1.3125rem',
            cursor: 'pointer',
          }),on:{"click":_vm.goPersonal}},[_vm._v(" "+_vm._s(_vm.$t("Personal page"))+" ")]),(_vm.isRaceAdmin)?_c('div',{style:({
            fontSize: '1.4375rem',
            color: '#F2F2F7',
            lineHeight: '2.0625rem',
            margin: '.75rem 0',
            display: 'flex',
            alignItems: 'center',
          })},[_c('div',{style:({
              cursor: 'pointer',
            }),on:{"click":function($event){return _vm.handleJumpPage(_vm.PAGE_REVIEW)}}},[_vm._v(" "+_vm._s(_vm.$t("end.application"))+" ")]),_c('div',{style:({
              minWidth: '4.375rem',
              height: '2.125rem',
              textAlign: 'center',
              background: '#FF6900',
              borderRadius: '3.6875rem',
              cursor: 'pointer',
            }),on:{"click":function($event){return _vm.handleJumpPage(_vm.PAGE_REVIEW)}}},[_vm._v(" "+_vm._s(_vm.confirmingCount > 999 ? "999+" : _vm.confirmingCount)+" ")])]):_vm._e(),_c('div',{style:({
            fontSize: '1.5625rem',
            color: '#F2F2F7',
            lineHeight: '2.0625rem',
            cursor: 'pointer',
            marginTop: _vm.isRaceAdmin ? '0rem' : '1.6875rem',
          }),on:{"click":_vm.logOut}},[_vm._v(" "+_vm._s(_vm.$t("Sign out"))+" ")])]):_c('div',{staticClass:"menu-container-not-Login"},[_c('div',{style:({
            fontSize: '1.5625rem',
            color: '#F2F2F7',
            textAlign: 'center',
            cursor: 'pointer',
          }),on:{"click":_vm.login}},[_vm._v(" "+_vm._s(_vm.$t("Sign in"))+" ")])])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }